import { Deserializable } from '../protocols/deserializable';
import { GoverningJurisdictionTypeId } from '../enum/shared/governing-jurisdiction-type-id';
import { GoverningJurisdictionType } from '../employers/employer-history/types/governing-jurisdiction-type';

export class VbWithdrawalAmount implements Deserializable {
  public governingJurisdictionId!: GoverningJurisdictionTypeId | null;
  public governingJurisdiction!: GoverningJurisdictionType;
  public accountBalance!: number;
  public startingMonth!: number;
  public remainingMonths!: number;
  public memberAge!: number;
  public spousalAge!: number;
  public triggerAge!: number;
  public minimumFactorAge!: number;
  public minimumFactor!: number;
  public minimumFactorTableYear!: number;
  public maximumFactorAge!: number;
  public maximumFactor!: number;
  public maximumFactorTableYear!: number;
  public minAnnualWithdrawalAmount!: number;
  public maxAnnualWithdrawalAmount!: number;
  // 0 unless an elected spouse's minimum was above the maximum, which is then raised to it
  public maximumRaisedToMinimumAmount!: number;

  public onDeserialize() {
    if (this.governingJurisdiction) {
      this.governingJurisdiction = window.injector.Deserialize.instanceOf(
        GoverningJurisdictionType,
        this.governingJurisdiction
      );
    }
  }
}
